let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1pvu3")).then(() => parcelRequire('8BpUu'));